import { SyntheticEvent } from 'react';

export const createPreventDefault = (fn: () => void) => (event: SyntheticEvent | Event) => {
    event.preventDefault();

    fn();
};
